import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaUser, FaCalendarAlt, FaVenusMars, FaPhone, FaSchool, FaBriefcase, FaHistory, FaMapMarkerAlt, FaInfoCircle } from 'react-icons/fa';
import Navbar from './Navbar';
import Footer from './Footer';

const RegistrationPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: '',
    mobileNumber: '',
    otherMobileNumber: '',
    schoolName: '',
    fatherJob: '',
    motherJob: '',
    previousArtClasses: 'no',
    previousAcademy: '',
    address: '',
    referralSource: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://formspree.io/f/xrbqwbya', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          age: '',
          gender: '',
          mobileNumber: '',
          otherMobileNumber: '',
          schoolName: '',
          fatherJob: '',
          motherJob: '',
          previousArtClasses: 'no',
          previousAcademy: '',
          address: '',
          referralSource: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 text-gray-800 font-sans">
      <Navbar />

      <section className="pt-32 pb-16 px-4">
        <div className="container mx-auto max-w-2xl">
          <div
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-600 hover:text-[#052e5a] transition-colors duration-300 mb-8 cursor-pointer"
          >
            <FaArrowLeft /> Back to Home
          </div>

          <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-100">
            <h1 className="text-4xl font-light mb-2 text-center" style={{ color: '#052e5a' }}>
              Student Registration
            </h1>
            <p className="text-gray-500 text-center mb-8 font-light">Join Donzi Art Academy and begin your artistic journey</p>

            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-700">
                Registration submitted successfully! We'll contact you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
                There was an error submitting your registration. Please try again.
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Full Name *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaUser className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter student's full name"
                  />
                </div>
              </div>

              {/* Age */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Age *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaCalendarAlt className="text-gray-400" />
                  </div>
                  <input
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    required
                    min="4"
                    max="18"
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter student's age"
                  />
                </div>
              </div>

              {/* Gender */}
              <div>
                <label className="block text-gray-700 font-light mb-2">Gender *</label>
                <div className="flex gap-6">
                  <label className="flex items-center p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-[#052e5a] transition-all duration-300 flex-1">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      checked={formData.gender === 'male'}
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    <FaVenusMars className="text-gray-400 mr-2" />
                    <span className="font-light">Male</span>
                  </label>
                  <label className="flex items-center p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-[#052e5a] transition-all duration-300 flex-1">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      checked={formData.gender === 'female'}
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    <FaVenusMars className="text-gray-400 mr-2" />
                    <span className="font-light">Female</span>
                  </label>
                </div>
              </div>

              {/* Mobile Number */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Mobile Number *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaPhone className="text-gray-400" />
                  </div>
                  <input
                    type="tel"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter primary mobile number"
                  />
                </div>
              </div>

              {/* Other Mobile Number */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Other Mobile Number</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaPhone className="text-gray-400" />
                  </div>
                  <input
                    type="tel"
                    name="otherMobileNumber"
                    value={formData.otherMobileNumber}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter alternative mobile number (optional)"
                  />
                </div>
              </div>

              {/* School Name */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">School Name *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaSchool className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="schoolName"
                    value={formData.schoolName}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter school name"
                  />
                </div>
              </div>

              {/* Father's Job */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Father's Job *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaBriefcase className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="fatherJob"
                    value={formData.fatherJob}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter father's occupation"
                  />
                </div>
              </div>

              {/* Mother's Job */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Mother's Job *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaBriefcase className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="motherJob"
                    value={formData.motherJob}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter mother's occupation"
                  />
                </div>
              </div>

              {/* Previous Art Classes */}
              <div>
                <label className="block text-gray-700 font-light mb-2">Did the child attend any art classes before? *</label>
                <div className="flex gap-6">
                  <label className="flex items-center p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-[#052e5a] transition-all duration-300 flex-1">
                    <input
                      type="radio"
                      name="previousArtClasses"
                      value="yes"
                      checked={formData.previousArtClasses === 'yes'}
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    <FaHistory className="text-gray-400 mr-2" />
                    <span className="font-light">Yes</span>
                  </label>
                  <label className="flex items-center p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-[#052e5a] transition-all duration-300 flex-1">
                    <input
                      type="radio"
                      name="previousArtClasses"
                      value="no"
                      checked={formData.previousArtClasses === 'no'}
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    <FaHistory className="text-gray-400 mr-2" />
                    <span className="font-light">No</span>
                  </label>
                </div>
              </div>

              {/* Previous Academy (conditional) */}
              {formData.previousArtClasses === 'yes' && (
                <div className="relative">
                  <label className="block text-gray-700 font-light mb-2">Name of Previous Academy</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FaSchool className="text-gray-400" />
                    </div>
                    <input
                      type="text"
                      name="previousAcademy"
                      value={formData.previousAcademy}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                      placeholder="Enter name of previous art academy"
                    />
                  </div>
                </div>
              )}

              {/* Address */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Address</label>
                <div className="relative">
                  <div className="absolute top-3 left-3 flex items-start pointer-events-none">
                    <FaMapMarkerAlt className="text-gray-400" />
                  </div>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300"
                    placeholder="Enter address (optional)"
                    rows="3"
                  />
                </div>
              </div>

              {/* Referral Source */}
              <div className="relative">
                <label className="block text-gray-700 font-light mb-2">Where did you hear about us? *</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaInfoCircle className="text-gray-400" />
                  </div>
                  <select
                    name="referralSource"
                    value={formData.referralSource}
                    onChange={handleChange}
                    required
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:border-transparent font-light transition-all duration-300 appearance-none"
                  >
                    <option value="">Select an option</option>
                    <option value="social_media">Social Media</option>
                    <option value="friend">Friend/Family</option>
                    <option value="school">School</option>
                    <option value="search">Search Engine</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              {/* Submit Button */}
              <div className="pt-6">
                <div
                  onClick={handleSubmit}
                  className={`w-full bg-[#052e5a] hover:bg-[#041d3a] text-white font-light py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#052e5a] focus:ring-opacity-50 cursor-pointer text-center ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
                    }`}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Registration'}
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RegistrationPage;